<template>
  <div
    v-if="config"
    class="tiles-widget"
  >
    <dashboard-widget-header
      v-if="config.name"
      :free-items-count="freeItemsCount"
      :icon="widgetIcon"
      :show-free-counts="showFreeCounts"
      :total-display-name="totalDisplayName"
      :total-items-count="totalItemsCount"
      :title="config.name"
    />
    <div class="single-row-container">
      <router-link
        v-for="item in navigationItems"
        :key="item.id"
        :to="item.route"
        @click="sendAnalytics(item)"
      >
        {{ item.name }}
      </router-link>
    </div>
  </div>
</template>

<script>
import DashboardWidgetHeader from '@components/dashboard-widgets/header';
import DashboardWidgetMixin from '@/mixins/dashboardWidget';
import GlobalMixin from '@/mixins/global';

export default {
  components: { DashboardWidgetHeader },
  mixins: [DashboardWidgetMixin, GlobalMixin],
  props: {
    config: {
      type: Object,
    },
  },
  methods: {
    sendAnalytics(navItem) {
      this.$analytics.events.selectedNavItem(navItem, this.navigationGroup, this.config.widgetType);
      if (navItem.destination === 'catalog') {
        this.$analytics.events.viewedCatalogHomePage({ id: this.config.id, name: this.config.name, type: 'Widget' });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.tiles-widget {
  @include padded-widget;

  .single-row-container {
    padding-left: rem-calc(32);
    padding-right: rem-calc(32);
    padding-bottom: 0 !important;

    a {
      background: #dbdbdb;
      border-radius: 4px;
      color: black;
      display: inline-block;
      font-size: 14px;
      font-weight: $semi-bold;
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 8px 16px;
      text-align: center;
      width: auto;

      &:hover {
        background: #a2a2a2;
        color: white;
      }
    }
  }
}
</style>
